
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { ROUTE_NAMES } from "@/routes";
import { IRootState } from "@/store/types";
import { TASK } from "@/store/task";
import {
  requiredIf,
  required,
  maxValue,
  minValue
} from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";

export default Vue.extend({
  data() {
    return {
      obtainedByEmailOrPost: false,
      fileLocation: "",
      isLoading: false
    };
  },
  computed: {
    task() {
      return store.state.application.followUpPersonalGuaranteeTask;
    },
    showModal: {
      get(): any {
        return !!this.task;
      },
      set(value: any) {
        if (!value) {
          store.commit(
            APPLICATION.NS(
              APPLICATION.MUTATIONS.SET_FOLLOW_UP_PERSONAL_GUARANTEE_TASK
            ),
            null
          );
          this.resetForm();
        }
      }
    },
    applicationId(): any {
      return this.$route.params && this.$route.params.id;
    }
  },
  methods: {
    async onPersonalGuaranteeObtained() {
      const action = APPLICATION.NS(
        APPLICATION.ACTIONS.PERSONAL_GUARANTEE_OBTAINED
      );

      if (this.task) {
        this.isLoading = true;
        const taskId = this.task.taskId;

        const success = await store.dispatch(action, {
          taskId,
          obtainedByEmailOrPost: this.obtainedByEmailOrPost,
          fileLocation: this.fileLocation
        });

        this.isLoading = false;
        if (success) {
          // hide modal and reset form values
          this.showModal = false;
          this.resetForm();
        }
      }
    },
    async resetForm() {
      await this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.LOAD_APPLICATION),
        this.applicationId
      );

      await this.$store.dispatch(
        TASK.NS(TASK.ACTIONS.LOAD_APPLICATION_TIMELINE),
        this.applicationId
      );
    }
  },
  validations: {
    fileLocation: {
      required: requiredIf(vm => vm.obtainedByEmailOrPost)
    }
  }
});
